import ClickOutside from '../../../plugins/clickoutside.js'
export default ClickOutside;